import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import { BrowserRouter } from 'react-router';

import { AppRouter } from '@/app/router';
import { ApiError } from '@/shared/api/client';

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // Повторять запрос с несостоявшейся авторизацией бессмысленно:
          // подпись не станет верной сама по себе.
          if (error instanceof ApiError && (error.isUnauthorized || error.isForbidden)) {
            return false;
          }
          return failureCount < 2;
        },
        // Человек возвращается из бота или после оплаты — данные должны
        // обновиться сами.
        refetchOnWindowFocus: true,
      },
    },
  });
}

/**
 * Вне Telegram приложение открывается в режиме просмотра (shared/lib/guest):
 * тарифы и устройство сервиса видны, покупка и аккаунт — через бота.
 */
export function App() {
  const client = useMemo(createQueryClient, []);

  return (
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
